var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",class:{button: _vm.button || _vm.enableHover},style:(_vm.containerStyle),on:{"click":function($event){_vm.$emit('click', $event)}}},[(_vm.enableHover)?_c('div',{class:(_vm.iconType + "_icon_hover"),style:(_vm.styleObj)}):_c('div',{class:[(_vm.iconType + "_icon"), { active: _vm.active } ],style:(_vm.styleObj)})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfe8edfc","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/Icon.vue
// module id = null
// module chunks = 